<template>
  <v-flex xs12>
    <v-card>
      <v-card-title class="headline">
        Services
        <add-case-service-form :case-id="caseId" :added-services="addedServiceIds"/>
        <add-case-service-by-slides-form :case-id="caseId"/>
      </v-card-title>

      <v-card-text v-if="devMode">
        <add-case-service-log-form :case-id="caseId"/>
        <event-type-select v-model="eventTypeFilter"/>
        <v-checkbox label="Show zero" v-model="showZeroServices"/>
      </v-card-text>

      <async-data :request-state="requestState">
        <v-card-text v-if="filteredItems.length > 0">
          <div>
            Full requested price: <pretty-amount :amount="fullRequestedPrice"/>
          </div>

          <div>
            Full executed price: <pretty-amount :amount="fullExecutedPrice"/>
          </div>

          <v-flex xs12>
            <div v-for="item in filteredItems"
                 :key="item.serviceId">
              <case-service-log-item
                :case-id="caseId"
                :service-id="item.serviceId"
                :old-requested-quantity="item.info.oldRequestedQuantity"
                :requested-quantity="item.info.requestedQuantity"
                :executed-quantity="item.info.executedQuantity"
                :checked-quantity="item.info.checkedQuantity"
                :item-price="item.info.itemPrice"
                :log="item.log"
                :eventTypes="eventTypeFilter"
              />
            </div>
          </v-flex>
        </v-card-text>
        <div v-else>
          Empty Log
        </div>
      </async-data>
    </v-card>
  </v-flex>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import _ from 'lodash';
    import CaseServiceLogDetails from './CaseServiceLogDetails'
    import CaseServiceLogItem from './CaseServiceLogItem'
    import AddCaseServiceLogForm from './AddCaseServiceLogForm'
    import AddCaseServiceForm from './AddCaseServiceForm'
    import AddCaseServiceBySlidesForm from './AddCaseServiceBySlidesForm'
    import ServiceAsBadge from '../../Ui/mcc/ServiceAsBadge'
    import AsyncData from '../../Ui/AsyncData'
    import {RequestState} from "../../../requestState";
    import CaseServiceLogEvent from "./CaseServiceLogEvent";
    import EventTypeSelect from "./EventTypeSelect";
    import PrettyAmount from '../../Ui/PrettyAmount'
    import bigInt from "big-integer"

    export default {
        name: 'case-service-log',
        components: {
            CaseServiceLogDetails,
            AddCaseServiceLogForm,
            AddCaseServiceForm,
            AddCaseServiceBySlidesForm,
            ServiceAsBadge,
            AsyncData,
            CaseServiceLogItem,
            CaseServiceLogEvent,
            EventTypeSelect,
            PrettyAmount
        },
        props: {
            caseId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                eventTypeFilter: ['ChangeRequested', 'ChangeExecuted', 'ChangeChecked', 'ChangeCharged', 'ChangePaid'],
                showZeroServices: false
            }
        },
        computed: {
            ...mapState({
                devMode: 'devMode'
            }),
            caseServiceLog() {
                return this.$store.getters.getCaseServiceLog(this.caseId)
            },
            items() {
                if (!this.caseServiceLog) {
                    return []
                }

                if (!this.caseServiceLog.response) {
                    return []
                }

                let log = this.caseServiceLog.response.log;
                let services = this.caseServiceLog.response.services;
                let groupedLog = _.groupBy(log, it => it.serviceId);
                return _.keys(groupedLog)
                    .sort()
                    .map(it => {
                        let serviceInfo = _.find(services, service => service.serviceId === it);
                        return {
                            serviceId: it,
                            info: serviceInfo,
                            log: groupedLog[it].sort((o1, o2) => {
                                const d1 = new Date(o1.occurredAt);
                                const d2 = new Date(o2.occurredAt);
                                return d1.getTime() - d2.getTime()
                            })
                        }
                    });
            },
            filteredItems() {
                if (this.showZeroServices) {
                    return this.items
                }

                return this.filterZeroItems(this.items)
            },
            addedServiceIds() {
                let notZeroItems = this.filterZeroItems(this.items);
                return _.map(notZeroItems, it => it.serviceId)
            },
            requestState() {
                if (!this.caseServiceLog) {
                    return RequestState.NotPerformed
                }

                return this.caseServiceLog.requestState
            },
            fullRequestedPrice() {
                let sum = _.reduce(this.caseServiceLog.response.services, (acc, it) => {
                    let price = bigInt(Math.round(it.itemPrice.amount * 100))
                    let fullPrice = price.multiply(it.requestedQuantity)
                    return acc.add(fullPrice)
                }, bigInt(0));

                return {
                    amount: Number(sum.toString()) / 100,
                    currency: 'rub'
                }
            },
            fullExecutedPrice() {
                let sum = _.reduce(this.caseServiceLog.response.services, (acc, it) => {
                    let price = bigInt(Math.round(it.itemPrice.amount * 100))
                    let fullPrice = price.multiply(it.executedQuantity)
                    return acc.add(fullPrice)
                }, bigInt(0));

                return {
                    amount: Number(sum.toString()) / 100,
                    currency: 'rub'
                }
            }
        },
        mounted() {
            this.fetchLogByCase({caseId: this.caseId})
        },
        methods: {
            ...mapActions({
                fetchLogByCase: 'fetchLogByCase'
            }),
            filterZeroItems(items) {
                return _.filter(items, service => {
                    return service.info.executedQuantity !== 0 || service.info.requestedQuantity !== 0
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/CaseServiceLog.vue